module.exports = __webpack_public_path__ + "static/media/logoMenu.59ec87c1.png";